Vendd.Scripts.load(function () {
    var $wrapper = $('.x-deliverypoint-widget-a');
    var model = null;

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    wrapper.showLoader = function () {
        $wrapper.addClass('x-loading');
    };

    wrapper.hideLoader = function () {
        $wrapper.removeClass('x-loading');
    };

    wrapper.update = function () {
        var html = Vendd.Handlebars.parse("deliveryPointWidget_A", model);
        $wrapper.html(html);
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.BindControl($wrapper));
    };

    $wrapper.on('click', '.js-remove-store', function (e) {
        e.stopPropagation();
        e.preventDefault();
        //Remove Selected Store
        Vendd.MessageBus.publish(wrapper, new Vendd.DeliveryPoint.Messages.ResetStore());
    });

    Vendd.MessageBus.subscribe(Vendd.DeliveryPoint.Messages.GetModelSuccess, wrapper, function (envelope) {
        $wrapper.removeClass('x-loading');
        model = envelope.message.data.model.data;

        //Extend model with Delivery Postal Code
        var deliveryPostalCode = Cookies.get('DeliveryPostalCode');
        if (model.HasDeliveryPoint) if (model.DeliveryPoint.Id == 1 && deliveryPostalCode && deliveryPostalCode !== 'undefined') model = { ...model, ...{ HasPostalCode: true, PostalCode: deliveryPostalCode } };
         
        wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.DeliveryPoint.Messages.GetModelFailed, wrapper, function (envelope) {
        $wrapper.removeClass('x-loading');
    });

    Vendd.MessageBus.subscribe(Vendd.DeliveryPoint.Messages.ResetStoreSuccess, wrapper, function (envelope) {
        //Reset Delivery Point
        Vendd.MessageBus.publish(wrapper, new Vendd.DeliveryPoint.Messages.ResetDeliveryPoint());
        //Remove cookie for Delivery Postal Code
        var deliveryPostalCode = Cookies.get('DeliveryPostalCode');
        if (deliveryPostalCode && deliveryPostalCode !== 'undefined') {
            Cookies.remove('DeliveryPostalCode');
        }
        //Remove Lazy Load Availability
        $('.x-product-details .lazyload-availability-container > span').remove();
            
        //reset model
        model = {};
        //update wrapper
        wrapper.update();      
    });

    wrapper.showLoader();
    Vendd.MessageBus.publish(wrapper, new Vendd.DeliveryPoint.Messages.GetModel());

});